module.exports = __webpack_public_path__ + "static/media/front.30198379.jpg";